import db from '@/services/db'

let $ = window.$

export default {
  init (widgets) {
    let instances = $('.grid-stack:not(div[class*="grid-stack-instance-"])').gridstack({
      verticalMargin: 10,
      handle: '.grid-stack-item__move',
      width: 24,
      minWidth: 900,
      cellHeight: 30
    })

    instances.each(function () {
      $(this).on('change', (event, items) => {
        if (!items) return
        for (let item of items) {
          let widgetId = item.el[0].getAttribute('widget-id')
          for (let widget of widgets) {
            if (widget['.key'] === widgetId) {
              let newCoords = {
                x: item.x,
                y: item.y,
                w: item.width,
                h: item.height
              }

              db.getRef('widgets').child(widgetId + '/gsOptions')
                .update(
                  newCoords,
                  function (err) {
                    if (err) throw err
                  }
                )
            }
          }
        }
      })
    })
  },
  update () {
    let el = $('.grid-stack-item:not(.ui-draggable)')
    let instance = el.closest('.grid-stack').data('gridstack')
    if (instance) {
      let coords = [
        $(el).data('gs-x'),
        $(el).data('gs-y'),
        $(el).data('gs-width'),
        $(el).data('gs-height')
      ]

      instance.addWidget(el, ...coords, true)
    }
  },
  destroy (el) {
    let instance = $(el).closest('.grid-stack').data('gridstack')
    instance.removeWidget(el)
  },
  freeze (statement, el) {
    let grid = $(el).data('gridstack')
    if (!grid) return
    if (statement) {
      grid.movable('.grid-stack-item', false)
      grid.resizable('.grid-stack-item', false)
    } else {
      grid.movable('.grid-stack-item', true)
      grid.resizable('.grid-stack-item', true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/gridstack.js